import Image from "next/image";

import { fitInfo } from "@/apiUtils/constants";
import NoImageSrc from "@/assets/images/no_image.svg";
import { CLink } from "@/components/common/customLink/CustomLink";
import { SizeAndFit } from "@/components/pdp/types";
import { getCloudinaryURL } from "@/utils/cloudinary";

type IProps = SizeAndFit["data"]["sizeGuideTab"] & {
  lang: "en" | "ar";
  category: string;
  categoryURL: string;
};

const SizeGuide = ({
  leftSideContent,
  rightSideContent,
  smallScreenTitle,
  lang,
  category,
  categoryURL,
}: IProps) => {
  return (
    <>
      <p className="lg:hidden">{smallScreenTitle}</p>
      <div className="flex flex-1 flex-col lg:items-center lg:justify-around lg:border-r lg:px-10">
        <span className="mb-2 mt-4 flex h-7 w-7 items-center justify-center rounded-full bg-primary-3 lg:hidden">
          <span className="font-semibold">1</span>
        </span>
        <h3 className="text-lg font-semibold">{leftSideContent?.title}</h3>
        <p className="py-3 lg:text-center">{leftSideContent?.description}</p>
        <div className="grid grid-cols-2 gap-5 py-7">
          {leftSideContent?.dimensionGuideImages?.map((item, idx) => (
            <Image
              key={item.key}
              src={item.media ? getCloudinaryURL(item.media) : NoImageSrc}
              alt={"guide_img"}
              width={200}
              height={200}
              className="w-full"
            />
          ))}
        </div>
        <div className="w-full py-5">
          <h3 className="text-center text-lg font-semibold">{leftSideContent?.ctaSectionTitle}</h3>
          <div className="flex flex-1 items-center justify-around gap-2 pt-3">
            {leftSideContent?.ctas?.map((item, idx) => (
              <div key={idx} className="text-center">
                <p className="mb-3 py-2 text-[12px] md:text-sm">
                  {fitInfo?.[lang]?.[category?.toLocaleLowerCase()]?.[item?.type!]}
                </p>
                <button
                  onClick={() => window.open(`${categoryURL}&ff=${item?.type}`, "_blank")}
                  className="bg-black px-3 py-3 text-size-10 font-semibold text-white md:px-5 lg:text-sm"
                >
                  {item?.title}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-1 flex-col lg:items-center lg:justify-around lg:px-10">
        <span className="mb-2 mt-4 flex h-7 w-7 items-center justify-center rounded-full bg-primary-3 lg:hidden">
          <span className="font-semibold">2</span>
        </span>
        <h3 className="text-lg font-semibold">{rightSideContent?.title}</h3>
        <p className="py-5 lg:text-center">{rightSideContent?.description}</p>
        <div className="grid grid-cols-3 items-center justify-around gap-10 py-4">
          {rightSideContent?.fitTypes?.map((item, idx) => (
            <Image
              key={idx}
              src={item?.media ? getCloudinaryURL(item.media) : NoImageSrc}
              alt="guide_img"
              width={200}
              height={200}
              className="mx-auto w-40"
            />
          ))}
        </div>
        <div className="grid grid-cols-3 items-center justify-around gap-2 pb-5 pt-4 md:gap-6">
          {rightSideContent?.fitTypes?.map((item, idx) => (
            <div key={idx} className="justify-center text-center">
              <p className="mb-3 py-2 text-[12px] md:text-sm">{item?.description}</p>
              <button
                onClick={() => window.open(`${categoryURL}&ff=${item?.type}`, "_blank")}
                className="bg-black px-3 py-3 text-size-10 font-semibold text-white md:px-5 lg:text-sm"
              >
                {item?.ctaTitle}
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SizeGuide;
